import React, { useEffect, useRef, useState } from "react";
import "./UploadAndListingComponent.css";
import { Apiurl } from "../../Pages/utils/page";
import moment from "moment";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import Select from "react-select";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import { IoIosInformationCircleOutline } from "react-icons/io";
import { Tooltip } from "bootstrap";
import { Modal, Pagination } from "react-bootstrap";
import { ClipLoader } from "react-spinners";
import UploadandListingEditProductModal from "./UploadandListingEditProductModal";
import UploadAndListingEditBannerModal from "./UploadAndListingEditBannerModal";
import UploadAndListingRelaunchModal from "./UploadAndListingRelaunchModal";
import UploadAndListingPickupLocationModal from "./UploadAndListingPickupLocationModal";
import { RxCross2 } from "react-icons/rx";


const UploadAndListingComponent = ({
  bannerDataImage,
  formData,
  setFormData,
  setSelectedImageIndex,
  setSelectedEditImageIndex,
  selectedImageIndex,
  selectedEditImageIndex,
  handleImageUpload,
  handleEditImageUpload,
  handleCropAndSave,
  images,
  editImages,
  cropperRefs,
  vendorProduct,
  setErrorMessage,
  errorMessage,
  setEditModal,
  setEditData,
  editData,
  editModal,
  handleCloseEditModal,
  editErrorMessage,
  setEditErrorMessage,
  handleUpdateProduct,
  loading,
  deliveryCharge,
  setCroppedImages,
  handleFilterTable,
  setChangeBannerModal,
  changeBannerModal,
  handleCloseEditBannerModal,
  setChangeData,
  changeData,
  handleUpdateBanner,
  setRelaunchModal,
  relaunchModal,
  handleRelaunch,
  handleCloseRelaunchModal,
  relaunchData,
  setRelaunchData,
  errorMessageRelaunch,
  setErrorMessageRelaunch,
  pickupLocationModal,
  setPickupLocationModal,
  setAddress,
  address,
  handleClose,
  handleSubmit,
  errorMessagePickup,
  setErrorMessagePickup,
  pickupLocationData,
  setOldImages,
  oldImages,
  categoriesData,
  setNumberofRecordSelected,
  totalPages,
  setpageIndex,
  prevPage,
  pageArray,
  changePage,
  pageIndex,
  nextPage,
  showingFrom,
  showingTo,
  totalRecord,
  setPageNumber,
  GetVendorProduct,
}) => {
  console.log(vendorProduct,'vendorProduct')
  const currentDate = moment().format("YYYY-MM-DD");
  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll(
      '[data-bs-toggle="tooltip"]'
    );
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new Tooltip(tooltipTriggerEl); // Explicitly initialize Tooltip
    });
  }, []);

  const onUpdateBannerCrop = (index) => {
    const cropper = cropperRefs.current[index];
    if (cropper && cropper.getCroppedCanvas) {
      const croppedCanvas = cropper.getCroppedCanvas({
        backgroundColor: "#ffffff", // Set background color for transparent areas
      });
      const base64Image = croppedCanvas.toDataURL("image/jpeg");
      const cleanedUrl = base64Image.split(",")[1]; // Remove base64 header

      // Update the specific cropped image in the array
      setCroppedImages((prev) => {
        const updated = [...prev];
        updated[index] = cleanedUrl;
        return updated;
      });
    }
  };
  const [inputValue, setInputValue] = useState("");
  const handleKeyDown = (e) => {
    const trimmedInput = inputValue.trim();

    if ((e.key === "Enter" || e.key === "," || e.key === " ") && trimmedInput) {
      e.preventDefault();

      if (!formData.Keywords.includes(trimmedInput)) {
        setFormData({
          ...formData,
          Keywords: [...formData.Keywords, trimmedInput],
        });
        setInputValue("");
      }
    } else if (e.key === "Backspace" && inputValue === "") {
      setFormData({
        ...formData,
        Keywords: formData.Keywords.slice(0, -1),
      });
    }
  };

  const removeKeyword = (index) => {
    const newKeywords = [...formData.Keywords];
    newKeywords.splice(index, 1);
    setFormData({ ...formData, Keywords: newKeywords });
  };
  return (
    <div className="banner_section" style={{ flex: "1" }}>
      <div className="container">
        <div className="row">
          <div className="col-lg-12 mb_commn_pd_0">
            <div className="product_banner">
              <div className="Cus_shadow">
                <div className="product_banner_scroll">
                  <div className="product_top_section">
                    {bannerDataImage?.map((item) => {
                      const banner = item?.BannerUrl.split('"');
                      const bannerUrl = `${Apiurl()}/${banner?.[1]}`;
                      return (
                        <div className="product-banner_wdth">
                          <div>
                            <img
                              src={bannerUrl}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "/Images/banner-default.jpg";
                              }}
                            />
                            <div className="checkbox_banner">
                              <input
                                type="checkbox"
                                id={item?.Id}
                                checked={item?.Id == formData?.BannerIds}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    BannerIds: e.target.checked ? item?.Id : "",
                                  });
                                  setErrorMessage({
                                    ...errorMessage,
                                    BannerIds: "",
                                  });
                                }}
                              />
                              <label for={item?.Id}>
                                Add products related to this banner
                              </label>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
              {errorMessage?.BannerIds ? (
                <div className="validation-message">
                  {errorMessage?.BannerIds}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-lg-12 mb_commn_pd_0">
            <div className="product_banner">
              <div className="Cus_shadow">
                <div className="product_top_section">
                  <button
                    type="button"
                    className="common_btn btn-primary"
                    onClick={() => {
                      setPickupLocationModal(true);
                    }}
                  >
                    Add Pickup Location
                  </button>
                </div>
                <div className="pickup-location-section mt-3">
                  <div className="row g-3">
                    {pickupLocationData?.map((item, index) => {
                      return (
                        <div className="col-md-6 col-lg-4 mb-3">
                          <div className="card p-3 shadow-sm">
                            <div className="card-body">
                              <h6 className="card-title">
                                <strong>PickUp Location ({index + 1}):</strong>
                              </h6>

                              <div className="card-text small text-muted overflow-auto">
                                <span className="d-block">
                                  <strong>Phone:</strong> {item?.PhoneNumber}
                                </span>
                                <span className="d-block">
                                  <strong>Address:</strong>{" "}
                                  {item?.AreaAndStreet}, Elite Web Technologies
                                </span>
                                <span className="d-block">
                                  <strong>Landmark:</strong>{" "}
                                  {item?.Landmark || "--"}
                                </span>
                                <span className="d-block">
                                  <strong>City:</strong> {item?.City},{" "}
                                  {item?.State} -{item?.PinCode}
                                </span>
                              </div>

                              <div className="form-check mt-2">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="product1"
                                />
                                <label
                                  className="form-check-label"
                                  for="product1"
                                >
                                  Select This Location
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-lg-12 mb_commn_pd_0">
            <div className="product_section">
              <div className="Cus_shadow">
                <div className="row">
                  <div className="col-lg-3 col-sm-4 col-12">
                    <div className="form-group">
                      <label className="required-label">
                        Product Name
                        <span className="required">*</span>
                        <button
                          type="button"
                          className="toottip_button"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-title="Name of your product"
                          aria-describedby="tooltip"
                        >
                          <IoIosInformationCircleOutline className="tooltip_icon_i" />
                        </button>
                      </label>

                      <p className="Uploadzz mb-0">
                        <input
                          type="text"
                          className="form-control"
                          placeholder=""
                          value={formData?.ProductName}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              ProductName: e?.target?.value,
                            });
                            setErrorMessage({
                              ...errorMessage,
                              ProductName: "",
                            });
                          }}
                        />
                      </p>
                      {errorMessage?.ProductName ? (
                        <div className="validation-message">
                          {errorMessage?.ProductName}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-4 col-12">
                    <div className="form-group">
                      <label className="required-label">
                        Product Category
                        <span className="required">*</span>
                        <button
                          type="button"
                          className="toottip_button"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-title="Category of the Product"
                          aria-describedby="tooltip"
                        >
                          <IoIosInformationCircleOutline className="tooltip_icon_i" />
                        </button>
                      </label>

                      <p className="Uploadzz mb-0">
                        <Select
                          options={categoriesData?.map((i) => ({
                            value: i?.Id,
                            label: i?.CatgeoryName,
                          }))}
                          isClearable
                          value={
                            categoriesData
                              ?.map((i) => ({
                                value: i?.Id,
                                label: i?.CatgeoryName,
                              }))
                              .find(
                                (cat) => cat.value == formData.CategoryId
                              ) || null
                          }
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              CategoryId: e?.value || "",
                            });
                            setErrorMessage({
                              ...errorMessage,
                              CategoryId: "",
                            });
                          }}
                        />
                      </p>
                      {errorMessage?.CategoryId ? (
                        <div className="validation-message">
                          {errorMessage?.CategoryId}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="col-lg-3 col-sm-4 col-12">
                    <div className="form-group">
                      <label className="required-label">
                        MRP(₹)
                        <span className="required">*</span>
                        <button
                          type="button"
                          className="toottip_button"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-title="MRP of the Product"
                          aria-describedby="tooltip"
                        >
                          <IoIosInformationCircleOutline className="tooltip_icon_i" />
                        </button>
                      </label>

                      <p className="Uploadzz mb-0">
                        <input
                          type="number"
                          min="1"
                          className="form-control"
                          placeholder=""
                          value={formData?.Mrp}
                          onChange={(e) => {
                            setFormData({ ...formData, Mrp: e?.target?.value });
                            setErrorMessage({
                              ...errorMessage,
                              Mrp: "",
                            });
                          }}
                        />
                      </p>
                      {errorMessage?.Mrp ? (
                        <div className="validation-message">
                          {errorMessage?.Mrp}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="col-lg-3 col-sm-4 col-12">
                    <div className="form-group">
                      <label>
                        Deal Price(₹)
                        <button
                          type="button"
                          className="toottip_button"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-title="Discounted price ( 0 If Product is in offer )"
                          aria-describedby="tooltip"
                        >
                          <IoIosInformationCircleOutline className="tooltip_icon_i" />
                        </button>
                      </label>

                      <p className="Uploadzz mb-0">
                        <input
                          type="number"
                          min="1"
                          className="form-control"
                          placeholder=""
                          value={formData?.DealPrice}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              DealPrice: e?.target?.value,
                            })
                          }
                        />
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-sm-4 col-12">
                    <div className="form-group">
                      <label>
                        Brand Name
                        <span className="required">*</span>
                        <button
                          type="button"
                          className="toottip_button"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-title="Brand Name of Your Product"
                          aria-describedby="tooltip"
                        >
                          <IoIosInformationCircleOutline className="tooltip_icon_i" />
                        </button>
                      </label>

                      <p className="Uploadzz mb-0">
                        <input
                          type="text"
                          className="form-control"
                          placeholder=""
                          value={formData?.BrandName}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              BrandName: e?.target?.value,
                            });
                            setErrorMessage({
                              ...errorMessage,
                              BrandName: "",
                            });
                          }}
                        />
                      </p>
                      {errorMessage?.BrandName ? (
                        <div className="validation-message">
                          {errorMessage?.BrandName}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="col-lg-3 col-sm-4 col-12">
                    <div className="form-group">
                      <label for="appt" className="required-label">
                        Entry Date
                        <span className="required">*</span>
                      </label>

                      <p className="Uploadzz mb-0">
                        <input
                          type="date"
                          className="form-control"
                          placeholder="Entry Date"
                          disabled
                          value={currentDate}
                        />
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-sm-4 col-12">
                    <div className="form-group">
                      <label for="appt" className="required-label">
                        From Publish Date
                        <span className="required">*</span>
                        <button
                          type="button"
                          className="toottip_button"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-title="Date from when your product will get published"
                          aria-describedby="tooltip"
                        >
                          <IoIosInformationCircleOutline className="tooltip_icon_i" />
                        </button>
                      </label>

                      <p className="Uploadzz mb-0">
                        <input
                          type="date"
                          className="form-control"
                          placeholder="Publish Date"
                          min={currentDate}
                          value={
                            moment(formData.FromPublishDate).format(
                              "YYYY-MM-DD"
                            ) || ""
                          }
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              FromPublishDate: moment(e?.target?.value).format(
                                "YYYY-MM-DDT00:00:00"
                              ),
                            });
                            setErrorMessage({
                              ...errorMessage,
                              FromPublishDate: "",
                            });
                          }}
                        />
                      </p>
                      {errorMessage?.FromPublishDate ? (
                        <div className="validation-message">
                          {errorMessage?.FromPublishDate}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="col-lg-3 col-sm-4 col-12">
                    <div className="form-group">
                      <label for="appt" className="required-label">
                        To Publish Date
                        <span className="required">*</span>
                        <button
                          type="button"
                          className="toottip_button"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-title="Your product last date"
                          aria-describedby="tooltip"
                        >
                          <IoIosInformationCircleOutline className="tooltip_icon_i" />
                        </button>
                      </label>

                      <p className="Uploadzz mb-0">
                        <input
                          type="date"
                          className="form-control"
                          placeholder="Publish Date"
                          min={moment(formData.FromPublishDate).format(
                            "YYYY-MM-DD"
                          )}
                          disabled={!formData?.FromPublishDate}
                          value={
                            moment(formData.ToPublishDate).format(
                              "YYYY-MM-DD"
                            ) || ""
                          }
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              ToPublishDate: moment(e?.target?.value).format(
                                "YYYY-MM-DDT00:00:00"
                              ),
                            });
                            setErrorMessage({
                              ...errorMessage,
                              ToPublishDate: "",
                            });
                          }}
                        />
                      </p>
                      {errorMessage?.ToPublishDate ? (
                        <div className="validation-message">
                          {errorMessage?.ToPublishDate}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="col-lg-3 col-sm-4 col-12">
                    <div className="form-group">
                      <label for="appt" className="required-label">
                        Select a Expiring Time of Item
                        <span className="required">*</span>
                        <button
                          type="button"
                          className="toottip_button"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-title="Your product will expire at this time"
                          aria-describedby="tooltip"
                        >
                          <IoIosInformationCircleOutline className="tooltip_icon_i" />
                        </button>
                      </label>

                      <input
                        type="time"
                        className="form-control"
                        value={
                          formData.ProductExpiringTime
                            ? moment(
                                formData.ProductExpiringTime.split("T")[0] +
                                  "T" +
                                  formData.ProductExpiringTime.split(
                                    "T"
                                  )[1].slice(0, 5)
                              ).format("HH:mm")
                            : ""
                        }
                        onChange={(e) => {
                          const selectedTime = e?.target?.value;
                          if (formData.ToPublishDate && selectedTime) {
                            const formattedDateTime = `${
                              formData.ToPublishDate.split("T")[0]
                            }T${selectedTime}`;
                            setFormData({
                              ...formData,
                              ProductExpiringTime: formattedDateTime,
                            });
                          }
                          setErrorMessage({
                            ...errorMessage,
                            ProductExpiringTime: "",
                          });
                        }}
                      />
                      {errorMessage?.ProductExpiringTime ? (
                        <div className="validation-message">
                          {errorMessage?.ProductExpiringTime}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="col-lg-3 col-sm-4 col-12">
                    <div className="form-group">
                      <label for="combinedDateTime">
                        Product Expire At
                        <button
                          type="button"
                          className="toottip_button"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-title="Product expiring Date and Time ( Winner will be Declare 1 minute after if product is in offer)"
                          aria-describedby="tooltip"
                        >
                          <IoIosInformationCircleOutline className="tooltip_icon_i" />
                        </button>
                      </label>

                      <input
                        type="datetime-local"
                        className="form-control"
                        readonly
                        disabled
                        value={
                          formData.ToPublishDate && formData.ProductExpiringTime
                            ? moment(
                                formData.ProductExpiringTime.split("T")[0] +
                                  "T" +
                                  formData.ProductExpiringTime.split(
                                    "T"
                                  )[1].slice(0, 5)
                              ).format("YYYY-MM-DDTHH:mm")
                            : ""
                        }
                      />
                    </div>
                  </div>

                  <div className="col-lg-3 col-sm-4 col-12">
                    <div className="form-group">
                      <label className="required-label">
                        Quantity
                        <span className="required">*</span>
                        <button
                          type="button"
                          className="toottip_button"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-title="Number of product you have to sell"
                          aria-describedby="tooltip"
                        >
                          <IoIosInformationCircleOutline className="tooltip_icon_i" />
                        </button>
                      </label>

                      <p className="Uploadzz mb-0">
                        <input
                          type="number"
                          className="form-control"
                          placeholder=""
                          value={formData?.Quantity}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              Quantity: e?.target?.value,
                            });
                            setErrorMessage({
                              ...errorMessage,
                              Quantity: "",
                            });
                          }}
                        />
                      </p>
                      {errorMessage?.Quantity ? (
                        <div className="validation-message">
                          {errorMessage?.Quantity}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="col-lg-6 col-sm-4 col-12">
                    <div className="form-group pro_option">
                      <div className="w-100">
                        <label className="required-label">
                          Product Options
                          <span className="required">*</span>
                          <button
                            type="button"
                            className="toottip_button"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            data-bs-title="What your product has to offer to final consumer"
                            aria-describedby="tooltip"
                          >
                            <IoIosInformationCircleOutline className="tooltip_icon_i" />
                          </button>
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="IsProductInOffer"
                          checked={formData?.IsProductInOffer === "bid"}
                          onChange={() => {
                            setFormData({
                              ...formData,
                              IsProductInOffer: "bid",
                            });
                            setErrorMessage({
                              ...errorMessage,
                              IsProductInOffer: "",
                            });
                          }}
                        />
                        <label>
                          Add To Offer
                          <button
                            type="button"
                            className="toottip_button"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            data-bs-title="User can bid the product to get free"
                            aria-describedby="tooltip"
                          >
                            <IoIosInformationCircleOutline className="tooltip_icon_i" />
                          </button>
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="IsProductInOffer"
                          checked={formData?.IsProductInOffer == "buy"}
                          onChange={() => {
                            setFormData({
                              ...formData,
                              IsProductInOffer: "buy",
                            });
                            setErrorMessage({
                              ...errorMessage,
                              IsProductInOffer: "",
                            });
                          }}
                        />
                        <label>
                          Add To Buy
                          <button
                            type="button"
                            className="toottip_button"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            data-bs-title="Product buy button will be available for the product"
                            aria-describedby="tooltip"
                          >
                            <IoIosInformationCircleOutline className="tooltip_icon_i" />
                          </button>
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="IsProductInOffer"
                          checked={formData?.IsProductInOffer === "contact"}
                          onChange={() => {
                            setFormData({
                              ...formData,
                              IsProductInOffer: "contact",
                            });
                            setErrorMessage({
                              ...errorMessage,
                              IsProductInOffer: "",
                            });
                          }}
                        />
                        <label>
                          Get in Touch
                          <button
                            type="button"
                            className="toottip_button"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            data-bs-title="Contact us button will be available for the product"
                            aria-describedby="tooltip"
                          >
                            <IoIosInformationCircleOutline className="tooltip_icon_i" />
                          </button>
                        </label>
                      </div>
                      {errorMessage?.IsProductInOffer ? (
                        <div className="validation-message">
                          {errorMessage?.IsProductInOffer}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  {formData?.IsProductInOffer === "bid" ? (
                    <div className="col-lg-3 col-sm-4 col-12">
                      <div className="form-group">
                        <label>
                          Recommended Points
                          <button
                            type="button"
                            className="toottip_button"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            data-bs-title="Recommeded bid point for the customer"
                            aria-describedby="tooltip"
                          >
                            <IoIosInformationCircleOutline className="tooltip_icon_i" />
                          </button>
                        </label>

                        <p className="Uploadzz mb-0">
                          <input
                            type="number"
                            className="form-control"
                            min="1"
                            placeholder="Points"
                            value={formData?.RecommendedBid}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                RecommendedBid: e?.target?.value,
                              });
                              setErrorMessage({
                                ...errorMessage,
                                RecommendedBid: "",
                              });
                            }}
                          />
                        </p>
                      </div>
                      {errorMessage?.RecommendedBid ? (
                        <div className="validation-message">
                          {errorMessage?.RecommendedBid}
                        </div>
                      ) : null}
                    </div>
                  ) : null}

                  <div className="col-lg-3 col-12">
                    <div className="form-group">
                      <label>
                        Upload Image{" "}
                        <span>
                          (700 * 400)
                          <span className="required">*</span>
                        </span>
                        <button
                          type="button"
                          className="toottip_button"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-title="Upload relevant images according to your product"
                          aria-describedby="tooltip"
                        >
                          <IoIosInformationCircleOutline className="tooltip_icon_i" />
                        </button>
                      </label>

                      <form id="imageForm">
                        <input
                          className="form-control custom-file-input"
                          accept="image/png, image/jpeg, image/gif"
                          id="inputFile1"
                          type="file"
                          multiple
                          onChange={handleImageUpload}
                        />
                      </form>
                    </div>
                    {errorMessage?.Images ? (
                      <div className="validation-message">
                        {errorMessage?.Images}
                      </div>
                    ) : null}
                  </div>

                  <div
                    style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}
                  >
                    {images.map((image, index) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          width: "300px",
                        }}
                      >
                        {/* Cropper for each image */}
                        <Cropper
                          src={image}
                          style={{
                            height: "200px",
                            width: "100%",
                            border: "1px solid #ccc",

                            marginBottom: "10px",
                          }}
                          aspectRatio={700 / 400}
                          guides={true}
                          initialAspectRatio={700 / 400}
                          responsive={true}
                          autoCropArea={1}
                          background={false}
                          onInitialized={(cropper) => {
                            cropperRefs.current[index] = cropper;
                          }}
                          crop={() => onUpdateBannerCrop(index)}
                        />
                        <input
                          type="radio"
                          id={`image-${index}`}
                          name="selectedImage"
                          value={index}
                          checked={selectedImageIndex === index}
                          onChange={() => setSelectedImageIndex(index)}
                        />
                        <label htmlFor={`image-${index}`}>
                          Select Image {index + 1}
                        </label>
                      </div>
                    ))}
                  </div>

                  {/* <button onClick={handleCropAndSave}>Crop and Save</button> */}
                  {/* <div>
                                        <h3>Cropped Image Data:</h3>
                                        <pre>{JSON.stringify(imageUrlArray, null, 2)}</pre>
                                    </div> */}

                  <div className="col-lg-12 col-sm-12 col-12">
                    <div className="form-group">
                      <label htmlFor="appt" className="required-label">
                        Keywords
                        <span className="required">*</span>
                        <button
                          type="button"
                          className="toottip_button"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-title="Write detail and attractive description of your item"
                          aria-describedby="tooltip"
                        >
                          <IoIosInformationCircleOutline className="tooltip_icon_i" />
                        </button>
                      </label>

                      <div className="Uploadzz mb-0">
                        <div className="keywords-container">
                          {formData?.Keywords?.map((keyword, index) => (
                            <span key={index} className="keyword-tag">
                              {keyword}
                              <RxCross2 
                              onClick={() => removeKeyword(index)}
                              />
                              {/* <button
                                type="button"
                                className="remove-btn"
                                onClick={() => removeKeyword(index)}
                              >
                                &times;
                              </button> */}
                            </span>
                          ))}
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Type and press enter"
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                            onKeyDown={handleKeyDown}
                          />
                        </div>
                        {errorMessage?.Keywords && (
                          <div className="validation-message">
                            {errorMessage.Keywords}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-12 col-sm-12 col-12">
                    <div className="form-group">
                      <label for="appt" className="required-label">
                        Description
                        <span className="required">*</span>
                        <button
                          type="button"
                          className="toottip_button"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-title="Write detail and attractive description of your item"
                          aria-describedby="tooltip"
                        >
                          <IoIosInformationCircleOutline className="tooltip_icon_i" />
                        </button>
                      </label>

                      <p className="Uploadzz mb-0">
                        <textarea
                          className="form-control"
                          placeholder=""
                          rows="5"
                          value={formData?.ProductDescription}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              ProductDescription: e?.target?.value,
                            });
                            setErrorMessage({
                              ...errorMessage,
                              ProductDescription: "",
                            });
                          }}
                        ></textarea>
                        {errorMessage?.ProductDescription ? (
                          <div className="validation-message">
                            {errorMessage?.ProductDescription}
                          </div>
                        ) : null}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-sm-4 col-12">
                    <div className="form-group">
                      <label>
                        Delivery Charges
                        <button
                          type="button"
                          className="toottip_button"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-title="Select delivery charges for your product"
                          aria-describedby="tooltip"
                        >
                          <IoIosInformationCircleOutline className="tooltip_icon_i" />
                        </button>
                      </label>
                      <Select
                        options={deliveryCharge?.map((item) => ({
                          value: item?.Id, // Use `Id` to find selected item later
                          label: item?.DeliveryCharge, // Display charge as label
                        }))}
                        value={
                          deliveryCharge
                            ?.map((i) => ({
                              value: i?.Id,
                              label: i?.DeliveryCharge,
                            }))
                            .find(
                              (cat) => cat.value == formData.DeliveryCharges
                            ) || null
                        }
                        onChange={(selectedOption) => {
                          const selectedItem = deliveryCharge?.find(
                            (item) => item?.Id == selectedOption?.value
                          );
                          setFormData((prev) => ({
                            ...prev,
                            DeliveryCharges: selectedItem?.Id || "",
                          }));
                        }}
                        placeholder="Select Delivery Charge"
                        isClearable
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-3 col-12">
                      <div className="form-group mt-2">
                        {loading == "add" ? (
                          <button
                            type="button"
                            className="common_btn btn-primary"
                          >
                            <ClipLoader
                              className="main_loader_home"
                              loading
                              size={15}
                            />
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="common_btn btn-primary"
                            onClick={() => handleCropAndSave()}
                          >
                            Upload
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-lg-12 mb-0">
            <div className="search-product-section">
              <div className="input-group search-bar">
                <div className="form-outline">
                  <input
                    type="search"
                    id="myInput"
                    placeholder="Search product by name"
                    className="form-control"
                    onChange={(e) => {
                      handleFilterTable(e?.target?.value);
                    }}
                  />
                </div>
                {/* <button type="button" className="common-btn search-btn">
                  <i className="bi bi-search"></i>
                </button> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-lg-12 mb_commn_pd_0">
            <div className="upload_banner_table">
              <div>
                <div className="row">
                  <div className="table-responsive table-sm custom-table">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Actions</th>
                          <th>Change Banner</th>
                          <th>Product Name</th>
                          <th>Brand Name</th>
                          <th>Images</th>
                          <th>Product Description</th>
                          <th>MRP</th>
                          <th>Deal Price</th>
                          <th>Quantity</th>
                          <th>Entry Date</th>
                          <th>From Publish Date</th>
                          <th>To Publish Date</th>
                          <th>Delivery Charges</th>
                          <th>Product In Publish?</th>
                          <th>Winner Announced?</th>
                          <th>Product In Offer?</th>
                        </tr>
                      </thead>
                      <tbody id="myTable">
                        {vendorProduct?.map((item, index) => {
                          const images = JSON.parse(item.Images || "[]");
                          const defaultImage = images.find(
                            (img) => img.Default === true
                          )?.Images;
                          return (
                            <tr>
                              <td>{showingFrom + index}</td>{" "}
                              {item?.ReLaunch === true ? (
                                <td>
                                  <button className="common_btn relaunch-btn">
                                    Relaunched
                                  </button>
                                </td>
                              ) : item?.IsWinnerDeclare == true &&
                                item?.ReLaunch == false ? (
                                <td>
                                  <button
                                    className="common_btn change_banner_butt"
                                    onClick={() => {
                                      setRelaunchData({
                                        ...relaunchData,

                                        Id: item?.Id,
                                        BannerIds: item?.BannerId,
                                        ProductName: item?.ProductName,
                                        Mrp: item?.Mrp,
                                        DealPrice:
                                          item?.DealPrice == null
                                            ? ""
                                            : item?.DealPrice,
                                        BrandName: item?.BrandName,
                                        EntryDate: item?.EntryDate,
                                        FromPublishDate: item?.FromPublishDate,
                                        ToPublishDate: item?.ToPushlishDate,
                                        ProductExpiringTime:
                                          item?.ToPushlishDate,
                                        Quantity: item?.Quantity,
                                        IsProductInOffer:
                                          item?.IsProductInOffer == true
                                            ? "bid"
                                            : item?.IsProductInOffer == false
                                            ? "buy"
                                            : item?.IsProductInOffer == null
                                            ? "contact"
                                            : null,
                                        ProductDescription:
                                          item?.ProductDescription,
                                        RecommendedBid:
                                          item?.RecommendedBid == null
                                            ? ""
                                            : item?.RecommendedBid,
                                        IsPublish: item?.IsPublish,
                                        DeliveryCharges: item?.DeliveryCharges,
                                        DeliveryChargesId:
                                          item?.DeliveryChargesId,
                                      });
                                      setRelaunchModal(true);
                                    }}
                                  >
                                    Relaunch
                                  </button>
                                </td>
                              ) : item?.IsWinnerDeclare == null ? (
                                <td>
                                  <button
                                    className="common_btn btn-primary w-100"
                                    onClick={async () => {
                                      const imagesArray = JSON.parse(
                                        item?.Images || "[]"
                                      ); // Parse the JSON string

                                      setOldImages(
                                        imagesArray?.map((img, idx) => ({
                                          Id: `${Date.now()}${idx}`,
                                          Images: img?.Images,
                                          Default: img?.Default, // Set clicked image as Default, others to false
                                          IsDelete: false,
                                          IsNewImageAdded:false
                                        }))
                                      );
                                      setEditData({
                                        ...editData,
                                        Id: item?.Id,
                                        BannerIds: item?.BannerId,
                                        ProductName: item?.ProductName,
                                        Mrp: item?.Mrp,
                                        DealPrice:
                                          item?.DealPrice == null
                                            ? ""
                                            : item?.DealPrice,
                                        BrandName: item?.BrandName,
                                        EntryDate: item?.EntryDate,
                                        FromPublishDate: item?.FromPublishDate,
                                        ToPublishDate: item?.ToPushlishDate,
                                        ProductExpiringTime:
                                          item?.ToPushlishDate,
                                        Quantity: item?.Quantity,
                                        IsProductInOffer:
                                          item?.IsProductInOffer == true
                                            ? "bid"
                                            : item?.IsProductInOffer == false
                                            ? "buy"
                                            : item?.IsProductInOffer == null
                                            ? "contact"
                                            : null,
                                        ProductDescription:
                                          item?.ProductDescription,
                                        RecommendedBid:
                                          item?.RecommendedBid == null
                                            ? ""
                                            : item?.RecommendedBid,
                                        IsPublish: item?.IsPublish,
                                        DeliveryCharges: item?.DeliveryCharges,
                                        DeliveryChargesId:
                                          item?.DeliveryChargesId,
                                        // Images: updatedImageUrlArray, // Base64 Images array
                                      });

                                      setEditModal(true);
                                    }}
                                  >
                                    Edit
                                  </button>
                                </td>
                              ) : null}
                              <td>
                                {item?.IsWinnerDeclare == null &&
                                item?.ReLaunch == false ? (
                                  <button
                                    className="common_btn change_banner_butt"
                                    onClick={() => {
                                      setChangeData({
                                        ...changeData,
                                        BannerId: item?.BannerId,
                                        ProductId: item?.Id,
                                      });
                                      setChangeBannerModal(true);
                                    }}
                                  >
                                    Change Banner
                                  </button>
                                ) : (
                                  <button className="common_btn cant_change_banner_butt">
                                    Can't Change Banner
                                  </button>
                                )}
                              </td>
                              <td>{item?.ProductName}</td>
                              <td>{item?.BrandName}</td>
                              <td>
                                <img
                                  className="tbl_img_size"
                                  src={`${Apiurl()}/${defaultImage}`}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src =
                                      "/Images/no-product-img-700.jpg";
                                  }}
                                />
                              </td>
                              <td>
                                <div className="table_desc_scroll">
                                  {item?.ProductDescription}
                                </div>
                              </td>
                              <td>{item?.Mrp}</td>
                              <td>{item?.DealPrice}</td>
                              <td>{item?.Quantity}</td>
                              <td className="table_form_date_wdth">
                                {moment(item?.EntryDate).format(
                                  "DD/MM/YYYY h:mm:ss a"
                                )}
                              </td>
                              <td className="table_form_date_wdth">
                                {moment(item?.FromPublishDate).format(
                                  "DD/MM/YYYY h:mm:ss a"
                                )}
                              </td>
                              <td className="table_form_date_wdth">
                                {moment(item?.ToPushlishDate).format(
                                  "DD/MM/YYYY h:mm:ss a"
                                )}
                              </td>
                              <td>{item?.DeliveryCharges}</td>
                              <td className="table_min_wdth_yes_no">
                                <span>
                                  {item?.IsPublish === true ? "Yes" : "No"}
                                </span>
                              </td>
                              <td className="table_min_wdth_yes_no">
                                <span>
                                  {item?.IsWinnerDeclare === true
                                    ? "Yes"
                                    : "No"}
                                </span>
                              </td>
                              <td className="table_min_wdth_yes_no">
                                <span>
                                  {item?.IsProductInOffer === true
                                    ? "Yes"
                                    : "No"}
                                </span>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>

                {vendorProduct?.length > 0 ? (
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="pagination-summary">
                        {vendorProduct?.length ? (
                          <span>
                            Showing {showingFrom?.toLocaleString()} -{" "}
                            {showingTo?.toLocaleString()} from {totalRecord}{" "}
                            Records
                            {/* Displaying{" "}
                              {Math.min(
                                pageNumber * (numberOfRecordSelected || 10) + 1,
                                totalRecord
                              )}
                              -
                              {Math.min(
                                (pageNumber + 1) *
                                  (numberOfRecordSelected || 10),
                                totalRecord
                              )}
                              of {filterAllData?.length || totalRecord} records */}
                          </span>
                        ) : (
                          <span>
                            Showing {showingFrom?.toLocaleString()} -{" "}
                            {showingTo?.toLocaleString()} from {totalRecord}{" "}
                            Records
                            {/* Displaying{" "}
                              {Math.min(
                                pageNumber * (numberOfRecordSelected || 10) + 1,
                                totalRecord
                              )}
                              -
                              {Math.min(
                                (pageNumber + 1) *
                                  (numberOfRecordSelected || 10),
                                totalRecord
                              )}
                              of {totalRecord} records */}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="pagination-controls">
                        <Pagination className="mt-1">
                          <Pagination.First
                            onClick={() => {
                              setpageIndex(1);
                              GetVendorProduct(1, "pag");
                            }}
                          />
                          <Pagination.Prev onClick={prevPage} />
                          {pageArray?.map((item, i) => (
                            <Pagination.Item
                              onClick={() => {
                                changePage(item);
                              }}
                              active={pageIndex === item}
                              key={i}
                            >
                              {item}
                            </Pagination.Item>
                          ))}
                          <Pagination.Next onClick={nextPage} />
                          <Pagination.Last
                            onClick={() => {
                              setpageIndex(totalPages);
                              GetVendorProduct(totalPages, "pag");
                            }}
                          />
                        </Pagination>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="records-per-page pull-right">
                        <label for="recordsPerPage">Records per page:</label>
                        <select
                          id="recordsPerPage"
                          className="form-select"
                          onChange={(e) => {
                            setPageNumber(0);
                            setpageIndex(1);
                            setNumberofRecordSelected(e?.target?.value);
                            GetVendorProduct("", "i", e?.target?.value);
                          }}
                        >
                          <option value="10">10</option>
                          <option value="15">15</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* user potential Detail Modal */}
      <UploadandListingEditProductModal
        editModal={editModal}
        handleCloseEditModal={handleCloseEditModal}
        editData={editData}
        setEditData={setEditData}
        editErrorMessage={editErrorMessage}
        setEditErrorMessage={setEditErrorMessage}
        currentDate={currentDate}
        deliveryCharge={deliveryCharge}
        handleEditImageUpload={handleEditImageUpload}
        editImages={editImages}
        cropperRefs={cropperRefs}
        selectedEditImageIndex={selectedEditImageIndex}
        setSelectedEditImageIndex={setSelectedEditImageIndex}
        setEditModal={setEditModal}
        loading={loading}
        handleUpdateProduct={handleUpdateProduct}
        oldImages={oldImages}
        setOldImages={setOldImages}
      />
      {/* edit banner modal */}
      <UploadAndListingEditBannerModal
        changeBannerModal={changeBannerModal}
        handleCloseEditBannerModal={handleCloseEditBannerModal}
        bannerDataImage={bannerDataImage}
        changeData={changeData}
        setChangeData={setChangeData}
        handleUpdateBanner={handleUpdateBanner}
        loading={loading}
      />

      {/* relaunch modal */}
      <UploadAndListingRelaunchModal
        relaunchModal={relaunchModal}
        handleCloseRelaunchModal={handleCloseRelaunchModal}
        handleRelaunch={handleRelaunch}
        loading={loading}
        setRelaunchData={setRelaunchData}
        relaunchData={relaunchData}
        errorMessageRelaunch={errorMessageRelaunch}
        setErrorMessageRelaunch={setErrorMessageRelaunch}
        currentDate={currentDate}
      />

      <UploadAndListingPickupLocationModal
        setAddress={setAddress}
        address={address}
        setPickupLocationModal={setPickupLocationModal}
        pickupLocationModal={pickupLocationModal}
        handleClose={handleClose}
        handleSubmit={handleSubmit}
        errorMessagePickup={errorMessagePickup}
        setErrorMessagePickup={setErrorMessagePickup}
        pickupLocationData={pickupLocationData}
        setOldImages={setOldImages}
      />
    </div>
  );
};

export default UploadAndListingComponent;
